import { computed } from 'vue';
import { convertToUnit } from '../../utils/component-lib.esm6.js';

//
var script = {
  name: 'SimpleTable',
  props: {
    dense: Boolean,
    fixedHeader: Boolean,
    height: [Number, String],
    gutterTop: Boolean,
    gutterBottom: Boolean
  },
  setup(props) {
    const classes = computed(() => {
      return {
        'v-simple-table--dense': props.dense,
        'v-simple-table--fixed-header': props.fixedHeader,
        'v-simple-table--fixed-height': !!props.height && !props.fixedHeader,
        'v-simple-table--gutter-top': props.gutterTop,
        'v-simple-table--gutter-btm': props.gutterBottom
      };
    });
    const wrapperStyles = computed(() => {
      return {
        maxHeight: convertToUnit(props.height)
      };
    });
    return {
      classes,
      wrapperStyles
    };
  }
};
export { script as default };